var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"12.5303","y1":"5.53033","x2":"7.58058","y2":"10.4801","stroke":"black","strokeWidth":"1.5","key":0}),React.createElement("line",{"y1":"-0.75","x2":"7","y2":"-0.75","transform":"matrix(0.707107 0.707107 0.707107 -0.707107 12 5)","stroke":"black","strokeWidth":"1.5","key":1}),React.createElement("line",{"x1":"4.75","y1":"15","x2":"4.75","y2":"20","stroke":"black","strokeWidth":"1.5","key":2}),React.createElement("line",{"x1":"19.25","y1":"15","x2":"19.25","y2":"20","stroke":"black","strokeWidth":"1.5","key":3}),React.createElement("line",{"x1":"19","y1":"19.25","x2":"5","y2":"19.25","stroke":"black","strokeWidth":"1.5","key":4}),React.createElement("line",{"x1":"12","y1":"7","x2":"12","y2":"16","stroke":"black","strokeWidth":"1.5","key":5})]);
}

Share.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Share;

Share.default = Share;
